import AgeGate from './AgeGate';
export default AgeGate;